import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import { resourcesInstallations } from "../../helpers/backend_helper";
import { useFormik } from "formik";
import Conditions from "./Sections/Conditions";
import OperativeTests from "./Sections/OperativeTests";
import VehicleFiles from "./Sections/VehicleFiles";
import General from "./Sections/General";
import {
  initialValues,
  parseFormValues,
  validationSchema,
} from "./Sections/yup.validation";

const AddUpdModal = ({ modal, setModal, getInstallations }) => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const parsedValues = parseFormValues(values);

      save(parsedValues);
    },
  });

  const save = (data) => {
    setErrors([]);
    setLoading(true);
    resourcesInstallations("post", data)
      .then((response) => {
        responseAction(response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const responseAction = (response) => {
    if (response.status) {
      handleClose();
      getInstallations();
      return;
    }
    setErrors(response?.response?.data?.error);
  };

  return (
    <div>
      <Modal isOpen={modal.show} size="lg">
        <ModalHeader>Agregar Instalación</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <General validation={validation} />
            <Conditions validation={validation} />
            <OperativeTests validation={validation} />
            <VehicleFiles validation={validation} />
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cancelar
            </Button>{" "}
            <Button color="primary" type="submit" disabled={loading}>
              <i className="fa fa-save"></i> {loading ? "Guardando..." : "Guardar"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
